import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { fetchWatermarkSettings, watermarkLogoUrl } from "./WatermarkOverlay";

/**
 * Phase 224b - the municipality's logo for document headers (receipt sheet). Shows the logo uploaded in Super Admin →
 * Tenant Config → Watermark whenever one exists (independent of the watermark on/off switch); falls back to the
 * generic building badge until a logo is uploaded. Plain <img>, so it prints as-is.
 */
export function MunicipalityLogo({ code, className = "h-12 w-12", testId = "municipality-logo" }) {
  const [info, setInfo] = useState(undefined);   // undefined = loading, null = none
  useEffect(() => {
    let alive = true;
    fetchWatermarkSettings(code).then((s) => { if (alive) setInfo(s && s.has_logo ? s : null); });
    return () => { alive = false; };
  }, [code]);

  if (info) {
    return (
      <img src={watermarkLogoUrl(code, info.logo_version)} alt={`${code ? code.toUpperCase() : "Municipality"} logo`}
        className={`${className} object-contain shrink-0`} draggable={false} data-testid={testId} />
    );
  }
  return (
    <div className={`${className} rounded-full border-2 border-black flex items-center justify-center shrink-0`} data-testid={`${testId}-fallback`} aria-hidden="true">
      <Building2 className="h-6 w-6" />
    </div>
  );
}
